<template>
  <BasePanel
    :error="error"
    :title="coating.title"
    :description="coating.description"
    :quantity="totalInteriorQuantity"
  />
</template>

<script>
import { mapGetters } from "vuex";
import BasePanel from "./CoatingResultsPanel.vue";

export default {
  name: "InteriorCoatingResultsPanel",

  components: { BasePanel },

  props: {
    coating: {
      type: Object,
      required: true,
    },
  },

  computed: {
    ...mapGetters("coatingCalculator", ["totalInteriorQuantity"]),

    error() {
      return Number.isNaN(this.totalInteriorQuantity);
    },
  },
};
</script>
